<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>

  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; margin-bottom : 40px;"><span style="font-size: 22px; border-bottom: solid 3px rgb(12, 92, 200);">用户入驻</span></p>'

      + '<p style="margin-bottom : 0px; "><span style="margin-left: 36px; font-size: 16px;font-weight: bold ">门禁权限开通</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 56px; font-size: 16px;">1）实验人员签署转化医学国家重大科技基础设施（上海）用户安全承诺书（附件1）</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 56px; font-size: 16px;">2）校内人员同时提交安全通过考试证明safexam.sjtu.edu.cn</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 56px; font-size: 16px;">3）校外人员连系你站安全员，填写问卷考试</span></p>'
      + '<p style="margin-bottom : 30px"><span style="margin-left: 56px; font-size: 16px;">4）经实验安全管理办老师审核后，在用户门禁权限开通申请表（附件2）上签字后，至用户办办理开通大楼权限</span></p>'

      + '<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;font-weight: bold">校外用户入驻办理事项：</span></p>'
      + '<p style="margin-bottom : 10px"><span style="margin-left: 56px; font-size: 16px;">1）访客卡（用于进出大楼门禁、校内就餐），填写用户卡制作信息表（附件3）</span></p>'
      + '<p style="margin-bottom : 30px"><span style="margin-left: 56px; font-size: 16px;">2）长期无线账号无线网络SJTU-Guest，填写无线网络申请表（附件4）</span></p>'

      +'<p style="margin-bottom : 0px"><span style="margin-left: 36px; font-size: 16px;font-weight: bold">附件下载：</span></p>'
      +'<p style="margin-bottom : 0px; margin-left: 56px; font-size: 16px;text-align: left"><a href="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/附件1-转化医学共享实验室安全承诺书.pdf" download="附件1-转化医学共享实验室安全承诺书.pdf">附件1-转化医学共享实验室安全承诺书.pdf</a></p>'
      +'<p style="margin-bottom : 0px; margin-left: 56px; font-size: 16px;text-align: left"><a href="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/附件2【2021版】用户门禁权限开通申请表.xlsx" download="附件2【2021版】用户门禁权限开通申请表.xlsx">附件2【2021版】用户门禁权限开通申请表.xlsx</a></p>'
      +'<p style="margin-bottom : 0px; margin-left: 56px; font-size: 16px;text-align: left"><a href="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/附件3-用户卡制作信息表【2021版】.xlsx" download="附件3-用户卡制作信息表【2021版】.xlsx">附件3-用户卡制作信息表【2021版】.xlsx</a></p>'
      +'<p style="margin-bottom : 0px; margin-left: 56px; font-size: 16px;text-align: left"><a href="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/附件4-无线网账号申请表.xls" download="附件4-无线网账号申请表.xls">附件4-无线网账号申请表.xls</a></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss" scoped>
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  margin-top: 0px;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/kyuser1/index.vue